import { BaseDto } from "./base.dto"
import { FileDto } from "./file.dto"

import { PagingDto } from "./paging.dto"
import { UserDto } from "./user.dto"

export class AdminFindSurveyDto extends PagingDto {
  searchText?: string
}

export class AdminSurveyResponseAnswerDto extends BaseDto {
  surveyQuestion: AdminSurveyQuestionDto
  question: string
  questionKh: string
  answer: string
  answerKh: string
  answerText: string
}

export class AdminSurveyResponseDto extends BaseDto {
  survey: AdminSurveyDto
  owner: UserDto
  surveyResponseAnswers: AdminSurveyResponseAnswerDto[]

  static create() {
    return new AdminSurveyResponseDto()
  }
}

export class AdminFindSurveyResponseDto extends PagingDto {

}

export class AdminSurveyDto extends BaseDto {
  enabled: boolean
  title: string
  description: string
  titleKh: string
  descriptionKh: string
  status: string
  publishedNotification: boolean
  image: FileDto
  websiteImage: FileDto
  questions: AdminSurveyQuestionDto[]
  imageId: string
  mobileImageId: string
  url: string

  static create() {
    return new AdminSurveyDto()
  }
}

export class AdminCreateSurveyDto {
  title: string
  description: string
  titleKh: string
  descriptionKh: string
  imageId: string
  mobileImageId: string
}

export class AdminUpdateSurveyDto {
  title?: string
  description?: string
  titleKh?: string
  descriptionKh?: string
  imageId?: string
  mobileImageId?: string
  status?: string
}

export class AdminSurveyQuestionDto extends BaseDto {
  question: string
  questionKh: string
  answerType: string
  surveyId: string
  enabled: boolean
  survey: AdminSurveyDto

  static create() {
    return new AdminSurveyQuestionDto()
  }
}

export class AdminSurveyAnswerDto extends BaseDto {
  answer: string
  answerKh: string
  surveyQuestionId: string
  isAnswerText: boolean
  enabled: boolean

  static create() {
    return new AdminSurveyAnswerDto()
  }
}

export class AdminCreateSurveyQuestionDto {
  question: string
  questionKh: string
  answerType: string
}

export class AdminCreateSurveyAnswerDto {
  answer: string
  answerKh: string
  surveyQuestionId: string
  isAnswerText: boolean
}

export class AdminUpdateSurveyQuestionDto {
  question?: string
  questionKh?: string
  enabled?: boolean
}

export class AdminUpdateSurveyAnswerDto {
  answer?: string
  answerKh?: string
  isAnswerText?: boolean
  enabled?: boolean
}

export enum SurveyStatus {
  Active = 'active',
  Closed = 'closed',
  Draft = 'draft'
}

export class AdminExportSurveyResponseDto {
  startDate?: Date
  endDate?: Date
  email?: string
}